import loadable from '@loadable/component'

const broadbandDealGroup = {
  variations: {
    default: loadable(() => import('./wrapper'))
  }
}

export default broadbandDealGroup
